import {FC} from 'react';
import clsx from 'clsx';
import LinkButton from 'components/LinkButton';
import CompanyToClientBlock from 'pages/Portal/components/CompanyToClientBlock';

export type ClientPortal = {
    clients: {
        documentCount: number;
        mid: string;
        name: string;
        url: string;
    }[];
    mid: string;
    partnerMid: string;
    partnerName: string;
};

type PortalRowProps = {
    disabled: boolean;
    portal: ClientPortal;
};

const PortalRow: FC<PortalRowProps> = ({disabled = false, portal}) => (
    <div key={portal.mid}>
        {portal.clients.map((client) => (
            <LinkButton
                key={client.mid}
                className={clsx(
                    'mb-6 flex w-full justify-between rounded-lg border border-grey-200 bg-white px-4 py-6 shadow-lg',
                    disabled && 'opacity-50',
                    !disabled && 'hover:border-transparent hover:bg-green-100',
                )}
                disabled={disabled}
                href={client.url}
                kind="custom"
            >
                <CompanyToClientBlock
                    clientName={client.name}
                    partnerName={portal.partnerName}
                    showArrowRight={true}
                />
            </LinkButton>
        ))}
    </div>
);

export {PortalRow};
